<template>
  <div class="external-login" :class="screenHeight < 700 ? 'small' : ''">
    <div class="page-main">
      <header></header>
      <main class="main-container clearfix">
        <div class="login-form">
          <div class="form-header">
            <selectLanguage
            :isShow="true"
            :isExternal="true"
            :userType="2"
            :url="setlanguageExternalNologin"
            />
            <div class="welcome">
              <img class="logo" alt="Logo" width="300" src="../../assets/images/external/logo.png">
              <h1>{{$t('Hello')}}</h1>
              <h3>{{$t('WelcomeSystem')}}</h3>
            </div>
          </div>
          <div class="form-content">
            <h2 class="form-title">{{$t('PleaseLogin')}}</h2>
            <div class="form-group">
              <i class="iconfont icon-user"></i>
              <input type="text" @keyup.enter="login" name="tel-mail" class="form-control" v-model="name" :placeholder="$t('PleasenumberOrEmail')" @blur="checkName">
              <label class="error-msg" v-show="errorMsgName">{{errorName}}</label>
            </div>
            <div class="form-group">
              <i class="iconfont icon-lock"></i>
              <div class="row">
                <div class="col-7">
                  <input type="text" @keyup.13="login" name="code" class="form-control" v-model="code" :placeholder="$t('verificationCode')" @blur="checkCode">
                  <label class="error-msg" v-show="errorMsgCode">{{errorCode}}</label>
                </div>
                <div class="col-5">
                  <button type="button" class="btn btn-light" @click="sendVerificationCode" :disabled="sendMsg">{{sendMsg ? countdown + this.$t('ResendAfter') : this.$t('GetVerificationCode')}}</button>
                </div>
              </div>
            </div>
            <div class="form-action">
              <button type="button" class="btn btn-gradient" @click="login">{{$t('PleaseLogin')}}</button>
            </div>
          </div>
        </div>
      </main>
      <footerExternal :isLoginPage="true"></footerExternal>
    </div>
    <div class="overlay"></div>
    <transition name="fade">
      <alertModal :modalType="'simple'" :isModalShown="modalTip" :modalTitle="modalTipText" @cancel="modalTip = false"></alertModal>
    </transition>
    <loading :active.sync="isLoading" :color="'#e42029'"></loading>
  </div>
</template>

<script>
import selectLanguage from '@/components/selectLanguage.vue';
import alertModal from '@/components/alertModal.vue';
import footerExternal from '@/components/footerExternal.vue';
import Loading from 'vue-loading-overlay';

import { API } from '@/config/config';
import cokeStorage, { checkNested, regExp } from '@/utils/utils';
import { sendVerificationCodeExternal, setLanguage } from '@/utils/api';
import myAuth from '@/utils/auth';

export default {
  name: 'ExternalLogin',
  components: {
    selectLanguage,
    alertModal,
    footerExternal,
    Loading,
  },
  data() {
    return {
      setlanguageExternalNologin: API.setlanguageExternalNologin,
      name: '',
      errorMsgName: false,
      errorName: this.$t('PleasenumberOrEmail'),
      code: '',
      errorMsgCode: false,
      errorCode: '',
      modalTip: false,
      modalTipText: '',
      token: '',
      sendMsg: false,
      countdown: 60,
      screenHeight: window.innerHeight,
      isLoading: false,
    }
  },
  created: function () {
    const localeLanguage = window.localStorage.getItem('localeLanguage') === 'en' ? 'en-US' : 'zh-CN';
    setLanguage(API.setlanguageExternalNologin + localeLanguage);
  },
  watch: {
    countdown: function() {
      if (this.countdown === 0) {
        this.sendMsg = false;
      }
    },
  },
  methods: {
    checkName() {
      const nameVal = this.name;
      if (nameVal == '') {
        this.errorMsgName = true;
        this.errorName = this.$t('PleasenumberOrEmail');
      } else {
        //console.log(this.errorMsgCode)
        if (regExp.phone.test(nameVal) || regExp.email.test(nameVal)) {
          this.errorMsgName = false;
        } else {
          this.errorMsgName = true;
          this.errorName = this.$t('PleaseCorrectphoneNumberOrEmail');
        }
      }
    },
    checkCode() {
      const codeVal = this.code;
      if (codeVal == '') {
        this.errorMsgCode = true;
        this.errorCode = this.$t('verificationCode');
      } 
      else if (this.token == '' ) {
        this.errorMsgCode = true;
        this.errorCode = this.$t('verificationToken');
      }
      else {
        this.errorMsgCode = false;
      }
    },
    sendVerificationCode() {
      const nameVal = this.name;
      this.errorMsgName = nameVal == '' ? true : this.errorMsgName;
      if (!this.errorMsgName) {
        this.sendMsg = true;
        this.countdown = 60;
        this.setBtnTxt();
        sendVerificationCodeExternal(nameVal).then((res) => {
          if (res.data.status == '004') {
            this.modalTip = true;
            this.modalTipText = res.data.message;
            this.sendMsg = false;
            this.countdown = 0;
          } else if (checkNested(res, 'data', 'content', 'model')) {
            this.token = res.data.content.model.token;
            this.modalTip = true;
            this.modalTipText = res.data.content.message === null ? this.$t('sentSuccessfully') : res.data.content.message;
          }
        });
      }
    },
    setBtnTxt() {
      const t = this;
      if (t.countdown > 0) {
        setTimeout(function() {
          t.countdown --;
          t.setBtnTxt();
        },1000);
      }
    },
    login() {
      const _this = this;
      const nameVal = _this.name;
      const codeVal = _this.code;
      const redirect_uri = _this.$route.query.redirect_uri == undefined ? '/external/detailIndex/0/0' : _this.$route.query.redirect_uri;
      const culture = window.localStorage.getItem('localeLanguage') === 'en' ? 'en-US' : 'zh-CN';
      const url = API.setlanguageExternal + culture;
      var query = _this.$route.query;
      _this.checkName();
      _this.checkCode();
      _this.errorCode = codeVal == '' ? this.$t('verificationCode') : _this.errorCode;
     if (!_this.errorMsgName && !_this.errorMsgCode) {
        _this.isLoading = true;
        myAuth.getAccessTokenExternal(_this.token, codeVal).then((model) => {
          if (query['redirect_uri']) {
            delete query['redirect_uri'];
          }
          if (query['message']) {
            delete query['message'];
          }
          myAuth.setLocalAccessToken(model);
          setLanguage(url).then((res) => {
            if (myAuth.checkToken()) {
              myAuth.getRefreshAccessTokenExternal().then((model) => {
                myAuth.setLocalAccessToken(model);
                if (model["role"] == "2") {
                  _this.$router.push({
                    path: "/external/carrier-new-application/0/0",
                    query: query
                  });
                  return;
                }
                _this.$router.push({
                  path: redirect_uri,
                  query: query,
                });
              });
            } else {
              if (model["role"] == "2") {
                _this.$router.push({
                  path: "/external/carrier-new-application/0/0",
                  query: query
                });
                return;
              }
              _this.$router.push({
                path: redirect_uri,
                query: query,
              });
            }
          });
        }).catch((error) => {
          _this.isLoading = false;
          _this.errorMsgCode = true;
          _this.errorCode = error;
        });
      }
    }
  },
  mounted () {
    const that = this;
    window.onresize = () => {
      return (() => {
        that.screenHeight = window.innerHeight;
      })();
    }
  },
};
</script>
<style scoped lang="scss">
@import '../../scss/variables.scss';
.form-control,
.btn {
  padding: 12px 12px 12px 38px;
  height: 46px;
  border: 0;
  background: #f6f6f6;
  font-size: 13px;
}
.btn {
  padding: 12px 0;
  display: block;
  width: 100%;
}
.btn-gradient {
  color: #fff;
  background-image: linear-gradient(73deg, #f36443, #e42029);
  &:hover {
    color: #fff;
  }
}
.select-language {
  position: relative;
  z-index: 10;
  padding: 0;
}
.error-msg {
  color: #e42029;
  font-size: 11px;
  margin-top: 5px;
  margin-bottom: 0;
  width: 100%;
}
.external-login {
  height: 100vh;
  overflow: hidden;
  background: url(../../assets/images/external/bg.jpg) no-repeat center;
  background-size: cover;
  .container {
    background: transparent;
  }
  .page-main {
    position: relative;
    z-index: 2;
    min-height: 100vh;
    height: 100%;
  }
  main {
    color: #fff;
    max-height: 100%;
    overflow: hidden;
    h1 {
      font-size: 35px;
      font-weight: bold;
      margin: 20px 0;
    }
    h3 {
      font-size: 22px;
      margin-bottom: 20px;
    }
  }
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.9;
    background-color: #3d3d3d;
    z-index: 1;
  }
  @include respond-to('sm-max') {
    background: transparent;
    main {
      color: #4a4a4a;
      h1 {
        font-size: 26px;
        margin-bottom: 10px;
      }
      h3 {
        font-size: 14px;
      }
    }
    .overlay {
      display: none;
    }
  }
  @include respond-to('ml') {
    background: transparent;
    main {
      color: #4a4a4a;
      h1 {
        font-size: 26px;
        margin-bottom: 10px;
      }
      h3 {
        font-size: 14px;
      }
    }
    .overlay {
      display: none;
    }
  }
}
.login-form {
  width: 380px;
  height: 504px;
  border-radius: 4px;
  background-color: #fff;
  position: relative;
  padding: 30px;
  color: #4a4a4a;
  float: right;
  &:before,
  &:after {
    content: '';
    position: absolute;
  }
  &:before {
    right: 0;
    bottom: 0;
    width: 180px;
    height: 99px;
    background: url(../../assets/images/external/invalid-name_4@2x.png);
    background-size: 100% 100%;
  }
  &:after {
    left: 28px;
    bottom: 20px;
    width: 61px;
    height: 61px;
    background: url(../../assets/images/external/invalid-name_5@2x.png);
    background-size: 100% 100%;
  }
  .form-header {
    height: 112px;
    &:before {
      right: 0;
      width: 192px;
      height: 106px;
      background: url(../../assets/images/external/copy@2x.png);
      background-size: 100% 100%;
    }
    &:after {
      left: 0;
      width: 235px;
      height: 112px;
      background: url(../../assets/images/external/copy-2@2x.png);
      background-size: 100% 100%;
    }
    &:before,
    &:after {
      content: '';
      position: absolute;
      top: 0;
    }
  }
  .welcome {
    position: absolute;
    left: -370px;
    width: 370px;
    top: 50%;
    transform: translate(0,-50%);
    color: #fff;
    .logo {
      padding-bottom: 60px;
    }
    @include respond-to('xl') {
      left: -580px;
      width: 580px;
    }
  }
  .form-title {
    font-size: 26px;
    font-weight: bold;
    line-height: 1;
    margin-bottom: 30px;
  }
  .form-content {
    border-radius: 4px;
    padding: 15px;
    box-shadow: 0 0 25px rgba(100,100,100,.15);
  }
  .form-group {
    position: relative;
    font-size: 13px;
    i {
      position: absolute;
      top: 12px;
      left: 12px;
      z-index: 9;
    }
    .icon-user {
      width: 16px;
      overflow: hidden;
    }
    .icon-lock {
      font-size: 18px;
    }
    .col-5 {
      padding-left: 10px;
    }
    .btn {
      color: #929292;
    }
  }
  .form-action {
    .btn {
      font-size: 15px;
      font-weight: bold;
    }
  }
  @include respond-to('sm-max') {
    width: 85%;
    height: auto;
    margin: 0 auto;
    border-radius: 0;
    float: none;
    position: static;
    padding: 0;
    .form-header {
      height: auto;
      padding: 30px 0 0;
      &:before {
        right: 0;
        width: 185px;
        height: 114px;
        background: url(../../assets/images/external/invalid-name@2x.png);
        background-size: 100% 100%;
      }
      &:after {
        left: 0;
        width: 278px;
        height: 134px;
        background: url(../../assets/images/external/invalid-name_3@2x.png);
        background-size: 100% 100%;
      }
    }
    .form-title {
      display: none;
    }
    .welcome {
      position: relative;
      z-index: 9;
      top: -24px;
      margin-bottom: -24px;
      left: 0;
      width: 100%;
      transform: none;
      color: #4a4a4a;
      .logo {
        width: 133px;
      }
    }
  }
  @include respond-to('ml') {
    width: 85%;
    height: auto;
    margin: 0 auto;
    border-radius: 0;
    float: none;
    position: static;
    padding: 0;
    .form-header {
      height: auto;
      padding: 30px 0 0;
      &:before {
        right: 0;
        width: 185px;
        height: 114px;
        background: url(../../assets/images/external/invalid-name@2x.png);
        background-size: 100% 100%;
      }
      &:after {
        left: 0;
        width: 278px;
        height: 134px;
        background: url(../../assets/images/external/invalid-name_3@2x.png);
        background-size: 100% 100%;
      }
    }
    .form-title {
      display: none;
    }
    .welcome {
      position: relative;
      z-index: 9;
      top: -24px;
      margin-bottom: -24px;
      left: 0;
      width: 100%;
      transform: none;
      color: #4a4a4a;
      .logo {
        width: 133px;
      }
    }
  }
}
.main-container {
  width: 750px;
  position: absolute;
  top: 43%;
  left: 50%;
  transform: translate(-50%,-50%);
  @include respond-to('xl') {
    width: 960px;
  }
  @include respond-to('sm-max') {
    padding-bottom: 110px;
    position: static;
    transform: none;
    width: 100%;
  }
  @include respond-to('ml') {
    padding-bottom: 110px;
    position: static;
    transform: none;
    width: 100%;
  }
}
.small {
  height: 700px;
  position: relative;
  @include respond-to('sm-max') {
    height: auto;
  }
  @include respond-to('ml') {
    height: auto;
  }
}
</style>
